var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.429,
    height: 24,
    viewBox: "0 0 18.429 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-svgrepo-com_1_",
    "data-name": "pdf-svgrepo-com (1)",
    transform: "translate(-6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M19.565,0H7.127C6.781,0,6.5.281,6.5.825V23.571A.645.645,0,0,0,7.127,24H24.3a.645.645,0,0,0,.627-.429V5.562c0-.3-.04-.394-.11-.465L19.832.11A.379.379,0,0,0,19.565,0Z",
    fill: "#e9e9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M37.5.151V5.229h5.078Z",
    transform: "translate(-17.714 -0.086)",
    fill: "#d9d7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M18.316,18.229h0a.688.688,0,0,1-.414-.14,1.027,1.027,0,0,1-.478-.961c.078-.7.941-1.428,2.565-2.172a28.768,28.768,0,0,0,1.623-4.607c-.428-.931-.843-2.139-.54-2.847a.822.822,0,0,1,.486-.521,2.1,2.1,0,0,1,.435-.074c.216,0,.406.278.54.45s.413.5-.16,2.915a13.7,13.7,0,0,0,2.181,3.241,8.338,8.338,0,0,1,1.439-.153c.671,0,1.078.156,1.244.479a.868.868,0,0,1-.167.926,1.139,1.139,0,0,1-.951.51,2.849,2.849,0,0,1-1.8-.979,20.535,20.535,0,0,0-3.783,1.209,12.16,12.16,0,0,1-1.021,1.822C19.07,17.942,18.691,18.229,18.316,18.229Zm1.141-2.2c-.916.515-1.289.938-1.316,1.176,0,.039-.016.143.185.3C18.39,17.485,18.763,17.315,19.457,16.032Zm5.844-1.9c.349.269.435.4.663.4a.646.646,0,0,0,.519-.189.678.678,0,0,0,.1-.178c-.053-.028-.123-.084-.5-.084A6.266,6.266,0,0,0,25.3,14.129Zm-3.2-2.821a30.554,30.554,0,0,1-1.146,3.242,21.414,21.414,0,0,1,2.784-.866A14.67,14.67,0,0,1,22.1,11.308Zm-.26-3.627a1.028,1.028,0,0,0,.041,1.378C22.288,8.153,21.859,7.675,21.84,7.681Z",
    transform: "translate(-6.239 -3.947)",
    fill: "#cc4b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M24.3,46.286H7.127a.627.627,0,0,1-.627-.627V39H24.929v6.659A.627.627,0,0,1,24.3,46.286Z",
    transform: "translate(0 -22.286)",
    fill: "#cc4b4c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4941",
    "data-name": "Group 4941",
    transform: "translate(10.462 18.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M16.447,47.242h-.7V42.924h1.242a1.743,1.743,0,0,1,.545.088,1.481,1.481,0,0,1,.483.264,1.376,1.376,0,0,1,.346.425,1.177,1.177,0,0,1,.132.56,1.531,1.531,0,0,1-.111.595,1.243,1.243,0,0,1-.311.448,1.4,1.4,0,0,1-.48.281,1.849,1.849,0,0,1-.621.1h-.522v1.559Zm0-3.785v1.711h.645a.766.766,0,0,0,.255-.044.642.642,0,0,0,.231-.144.7.7,0,0,0,.17-.278,1.318,1.318,0,0,0,.064-.442,1.2,1.2,0,0,0-.029-.243.7.7,0,0,0-.12-.264.71.71,0,0,0-.255-.211.947.947,0,0,0-.434-.085h-.527Z",
    transform: "translate(-15.744 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M27.57,44.963a3.172,3.172,0,0,1-.114.911,2.265,2.265,0,0,1-.29.633,1.49,1.49,0,0,1-.4.4,1.984,1.984,0,0,1-.425.22,1.755,1.755,0,0,1-.375.094,2.5,2.5,0,0,1-.252.02H24.084V42.924h1.3a2.471,2.471,0,0,1,.958.173,1.989,1.989,0,0,1,.686.46,1.888,1.888,0,0,1,.407.653A2.163,2.163,0,0,1,27.57,44.963Zm-2.086,1.764a1.164,1.164,0,0,0,1.031-.457,2.319,2.319,0,0,0,.316-1.324,2.243,2.243,0,0,0-.064-.533,1.141,1.141,0,0,0-.249-.477,1.314,1.314,0,0,0-.5-.346,2.157,2.157,0,0,0-.82-.132h-.41v3.27h.7Z",
    transform: "translate(-20.51 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M35.313,43.457v1.359h1.8v.48h-1.8v1.945H34.6V42.924h2.7v.533Z",
    transform: "translate(-26.518 -42.924)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfColorIcon);
export default __webpack_public_path__ + "static/media/pdf-color-icon.7a9afcc1f011def4f8e0af5051c25e70.svg";
export { ForwardRef as ReactComponent };